export default __webpack_public_path__ + "static/media/monkey16.05335cff.jpeg";